import { log } from './log';

export const videoSegment = async (jwPlayerSiteId: string, mediaId: string): Promise<string> => {
  if (!jwPlayerSiteId) {
    log('pixels', 'videoSegment', 'Site ID is not found');
    return '';
  }

  const segments = await fetch(
    `https://content.jwplatform.com/v2/sites/${jwPlayerSiteId}/base_segments?media_ids=${mediaId}`
  )
    .then(response => response.json())
    .catch(ex => {
      log('pixels', 'videoSegment', ex);
      return null;
    });

  try {
    const ids = Object.values(segments?.media_ids[mediaId] || []).flat();
    return [...new Set(ids)].join(',');
  } catch (ex) {
    console.error(ex);
    return '';
  }
};
